module.exports = __webpack_public_path__ + "img/18.9.TU.d5a628ef.png";